export default __webpack_public_path__ + "static/media/logo.8ab736c0.svg";